import JWT from 'jsonwebtoken'

// Saving token to cookies after successfull login (from login page or in router after using magic link)
export function saveJwtToken (vm, token) {
  // Remove session cookie if existing
  if (vm.$cookies.isKey('session')) {
    vm.$cookies.remove('session')
  }
  // Create new session cookie
  vm.$cookies.set('session', token, Infinity)
}

// set user related attributes from token before every action - to keep attributes between refreshes
export async function initUserInSession (vm) {
  if (vm.$cookies.isKey('session')) {
    // Read token from cookie
    let token = vm.$cookies.get('session')

    // Add token to all HTTP headers (for authorization)
    vm.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token

    // Read user from cookie/token and save to store
    const user = JWT.decode(token)
    vm.$store.commit('setCurrentUser', user)

    // Save FE version to local storage
    const frontendVersion = user.frontendVersion
    window.localStorage.setItem('retObserverFrontendVersion', frontendVersion)

    // Getting deviceTypes and save to store
    await vm.$store.dispatch('getDeviceTypes')

    // Setting team and saving it to store (if not already set)
    if (!vm.$store.state.auth.currentTeam.id) {
      console.log('[main-window] Looking for my team')
      try {
        await vm.$store.dispatch('getItems', { model: { name: 'teams' } })
        const team = vm.$store.state.items.teams.find(i => i.userId.toString() === user.id.toString())
        if (team) { // If found, saving it to the store
          vm.$store.commit('setCurrentTeam', team)
        } else {
          console.warn('[login] ERR - User does not have team')
        }
      } catch (error) {
        console.error(error)
      }
    }

    // Setting language and saving it to store
    // language is changed only after logout/login (only when this method gets called)
    if (user.language) {
      if (['en', 'cs', 'fr', 'pl'].includes(user.language) && user.language !== window.localStorage.getItem('userLanguage')) {
        window.localStorage.setItem('userLanguage', user.language)
        window.localStorage.setItem('languageChanged', 'true')
      }
    }

    // Setting currentOwnerId
    vm.$store.commit('setCurrentOwnerId', user.ownerId)

    // Returning the user
    return user
  }
}
